import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import "../styles/guaranteePage.scss";
import { useDispatch } from "react-redux";
import { initAppBrowser } from "@actions/initApp";

const Guarentee = ({ imgPrefix }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(initAppBrowser(["messages"]));

    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="header-t-175-sm-150 container static-content-container">
      <Helmet title={`The 45 Day CardCash Guarantee`} />
      <div className="row" style={{ paddingTop: "40px" }}>
        <div className="col-md-12">
          <div
            className="col-md-2"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <img
              src={`${imgPrefix}45day.png`}
              className="hidden-md-down"
              style={{ width: "60%", marginTop: "65px", maxWidth: "100px" }}
              alt=""
            />
          </div>
          <div className="col-md-8">
            <h1 className="mar-b-20">Save with Confidence!</h1>
            <div className="mar-b-30">
              <b>
                100% Risk Free 45 Day Money Back Guarantee For Any Balance Discrepancies
              </b>
              <p>
                CardCash customers use pre-owned discounted gift cards to save
                you money on everything they buy. We offer a 100% guarantee that
                every gift card you purchase from CardCash will be valid at the
                merchant for the dollar amount specified on your order for a
                full 45 days from the date of purchase. If you encounter a card
                with a balance discrepancy within 45 days of your purchase,
                contact us immediately for a full refund.
              </p>
            </div>
            <div className="mar-b-30">
              <b>Why do gift cards go bad?</b>
              <p>
                Unlike a carton of milk past its expiration date, gift cards do
                not go bad all by themselves. The two most common reasons gift
                cards lose their balance are: (1) The card was purchased with a
                stolen credit card and subsequently canceled by the issuing
                company. (2) The original owner used the card number after
                selling it to CardCash.{" "}
              </p>
            </div>
            <b>How can you protect yourself?</b>
            <p>
              These simple steps will keep you safe from unscrupulous sellers
              and fraudulently obtained gift cards:
            </p>
            <ol className="mar-b-30">
              <li className="mar-b-0">
                Check your gift card balance before going to the store
              </li>
              <li className="mar-b-0">
                Use the full balance of the card within 45 days of the purchase.
                IMPORTANT! Even if you checked the balance and it was fine
                within 45 days, the guarantee expires at 45 days from your
                purchase date. All you need to do is use the card within 45
                days.{" "}
              </li>
              <li className="mar-b-0">
                Report any balance discrepancy within 45 days of the purchase to
                claims@cardcash.com{" "}
              </li>
            </ol>
            <div className="mar-b-30">
              <b>Our Commitment To You</b>
              <p>
                We employ the industry’s best anti fraud procedures to do
                whatever we can to prevent this from happening. Of course, we
                can’t share all of the steps we take with you, but they always
                include vetting anyone who sells us gift cards, match patterns
                against our advanced fraud detection algorithms as well as
                verifying each gift card balances multiple times.{" "}
              </p>
              <p>
                In order to make the CardCash experience the best it can be for
                both buyers and sellers, we maintain the highest security
                standards and have a zero tolerance policy for fraudulent
                activity.{" "}
              </p>
            </div>
            <div>
              <b>Abuse of the CardCash Guarantee</b>
              <p>
                We reserve the right to suspend or cancel the registration of
                any Buyer or Seller who we believe, in our sole discretion,
                abuses or attempts to abuse the CardCash Gift Card Guarantee. We
                will report any such abuse to the appropriate legal authorities.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(state => ({ imgPrefix: state.config.imgPrefix }))(
  Guarentee
);
